export default function useAnalytics () {
  const { $posthog } = useNuxtApp()

  const track = (event: string, properties: Record<string, any> = {}) => {
    // Capture event with PostHog
    if ($posthog) {
      ($posthog as any).capture(event, properties)
    }
  }

  const identify = (userId: string, traits: Record<string, any> = {}) => {
    // Identify with PostHog
    if ($posthog) {
      ($posthog as any).identify(userId, traits)
    }
  }

  return { track, identify }
}
